import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { API_URL } from '../config';

const District = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [countries, setCountries] = useState([]);
  const [selectedCountry, setSelectedCountry] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(`${API_URL}api/district/fatchDistrictsnews`);
        if (response.data.status === 'success') {
          setData(response.data.data || []);
          const uniqueCountries = [...new Set(response.data.data.map(item => item.DistictName))];
          setCountries(uniqueCountries);
        }
      } catch (err) {
        console.error(err);
        setError('No Updates available at this moment.');
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const filteredData = selectedCountry
    ? data.filter(item => item.DistictName === selectedCountry)
    : data;

  const renderMedia = (item) => {
    if (item.link) {
      return (
        <iframe
          src={item.link}
          title={item.DistictName}
          className="img-fluid w-100"
          style={{ objectFit: 'cover', height: '200px' }}
        />
      );
    } else if (item.image) {
      const imageUrl = `${API_URL}${item.image}`;
      return (
        <img
          src={imageUrl}
          alt={item.DistictName}
          className="img-fluid w-100"
          style={{ objectFit: 'cover', height: '200px' }}
        />
      );
    } else {
      return (
        <div
          className="img-fluid w-100 bg-secondary d-flex justify-content-center align-items-center"
          style={{ height: '200px' }}
        >
          No media available
        </div>
      );
    }
  };

  const renderLoading = () => {
    const text = "Loading...";
    const rings = 2;
    const ringSectors = 30;

    return (
      <div className="preloader-container">
        <div className="preloader" id="preloader">
          {[...Array(rings)].map((_, ringIndex) => (
            <div key={ringIndex} className="preloader__ring">
              {[...Array(ringSectors)].map((_, sectorIndex) => (
                <div
                  key={sectorIndex}
                  className="preloader__sector"
                  style={{
                    transform: `rotateY(${(360 / ringSectors) * sectorIndex}deg) translateZ(7rem)`
                  }}
                >
                  {text[sectorIndex] || ''}
                </div>
              ))}
            </div>
          ))}
        </div>
        <style jsx>{`
          .preloader-container, .preloader {
            display: flex;
          }

          .preloader-container {
            background: #ebeef0;
            color: #015d72;
            font: 1em 'Dosis', sans-serif;
            height: 100vh;
            line-height: 1.5;
            perspective: 40em;
          }

          .preloader {
            animation: tiltSpin 8s linear infinite;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            margin: auto;
            width: 17em;
            height: 17em;
            transform-style: preserve-3d;
            margin-bottom:400px;
          }

          .preloader__ring {
            animation: spin 4s linear infinite;
            font-size: 2em;
            position: relative;
            height: 3rem;
            width: 1.5rem;
            transform-style: preserve-3d;
          }

          .preloader__ring:nth-child(even) {
            animation-direction: reverse;
          }

          .preloader__sector {
            font-weight: 600;
            position: absolute;
            top: 0;
            left: 0;
            text-align: center;
            text-transform: uppercase;
            transform: translateZ(7rem);
          }

          .preloader__sector, .preloader__sector:empty:before {
            display: inline-block;
            width: 100%;
            height: 100%;
          }

          .preloader__sector:empty:before {
            background: linear-gradient(transparent 45%, currentColor 45% 55%, transparent 55%);
            content: "";
          }

          @keyframes tiltSpin {
            from {
              transform: rotateY(0) rotateX(30deg);
            }
            to {
              transform: rotateY(1turn) rotateX(30deg);
            }
          }

          @keyframes spin {
            from {
              transform: rotateY(0);
            }
            to {
              transform: rotateY(1turn);
            }
          }
        `}</style>
      </div>
    );
  };

  if (loading) return renderLoading();

  if (error) return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      height: 'calc(100vh - 300px)',
      backgroundColor: 'white'
    }}>
      <div style={{ color: 'red', marginBottom: '1rem' }}>{error}</div>
      <button
        onClick={() => window.location.reload()}
        style={{
          padding: '0.5rem 1rem',
          backgroundColor: '#3498db',
          color: 'white',
          border: 'none',
          borderRadius: '4px',
          cursor: 'pointer'
        }}
      >
        Retry
      </button>
    </div>
  );

  return (
    <div className="container-fluid mt-5 pt-3" style={{ backgroundColor: 'white' }}>
      <div className="container">
        <div className="row">
          <div className="col-lg-12">
            {/* Country Selection Section */}
            <div className="col-12 mb-4">
              <div className="section-title" style={{
                color: 'white',
                backgroundColor: '#002147',
                marginBottom: '20px',
                padding: '10px'
              }}>
                <h4 className="section-title">
                  <span style={{ color: 'white' }}>देश चुनें</span>
                </h4>
              </div>
              <div className="d-flex flex-wrap gap-2 p-3 border">
                {countries.map((country) => (
                  <button
                    key={country}
                    onClick={() => setSelectedCountry(country)}
                    className={`btn ${selectedCountry === country ? 'btn-primary' : 'btn-outline-primary'} me-2 mb-2`}
                  >
                    {country}
                  </button>
                ))}
                {selectedCountry && (
                  <button
                    onClick={() => setSelectedCountry(null)}
                    className="btn btn-outline-secondary me-2 mb-2"
                  >
                    सभी जनपदीय
                  </button>
                )}
              </div>
            </div>

            <div className="row">



              <div className="col-12">
                <div
                  className="section-title"
                  style={{
                    color: 'white',
                    backgroundColor: '#002147',
                    marginBottom: '20px',
                    padding: '10px'
                  }}
                >
                  <h4 className="section-title">
                    <span style={{ color: 'white' }}>
                      {selectedCountry ? `${selectedCountry} की खबरें` : 'देश'}
                    </span>
                  </h4>
                </div>
              </div>

              {filteredData.map((item) => (
                <div className="col-lg-4 col-md-6 mb-4" key={item.id}>
                  <div className="position-relative mb-3" style={{ height: '450px' }}>
                    {renderMedia(item)}
                    <div className="allcolor border border-top-0 p-4" style={{ height: '250px', overflow: 'hidden' }}>
                      <div className="mb-2">
                        <span className="badge bg-primary">{item.DistictName}</span>
                        <small className="ms-2 text-muted">
                          {new Date(item.created_at).toLocaleDateString('hi-IN')}
                        </small>
                      </div>




                      <Link
                        to={`/districtsnews/${item.id}`}
                        className="alla h2 d-block mb-3 text-uppercase font-weight-bold"
                        onClick={() => {
                          window.scrollTo({ top: 0, behavior: 'smooth' });
                        }}
                      >
                        {item.short_description}
                      </Link>
                      <p className="allp  " style={{ height: '50px', overflow: 'hidden', textOverflow: 'ellipsis', display: '-webkit-box', WebkitLineClamp: 3, WebkitBoxOrient: 'vertical' }}>
                        {item.description || 'No description available'}
                      </p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default District;